import { render } from "./CaptionEditor.vue?vue&type=template&id=490d4568&scoped=true"
import script from "./CaptionEditor.vue?vue&type=script&lang=js"
export * from "./CaptionEditor.vue?vue&type=script&lang=js"

import "./CaptionEditor.vue?vue&type=style&index=0&id=490d4568&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490d4568"]])

export default __exports__